"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OraclePillButton = void 0;
var react_1 = __importDefault(require("react"));
var OraclePillButton = function (_a) {
    var children = _a.children, onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.selected, selected = _c === void 0 ? false : _c, _d = _a.type, type = _d === void 0 ? 'button' : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, ariaLabel = _a.ariaLabel, ariaPressed = _a.ariaPressed;
    var classes = [
        'oracle-pill-button',
        className,
        selected ? 'oracle-pill-button--selected' : '',
    ].filter(Boolean).join(' ');
    return (react_1.default.createElement("button", { type: type, className: classes, onClick: onClick, disabled: disabled, "aria-label": ariaLabel, "aria-pressed": ariaPressed }, children));
};
exports.OraclePillButton = OraclePillButton;
